/* ============================================================
   CELESTIAL VAULT — language facet (query-param, client-side)
   Replaces the old tag-URL behaviour, which had two defects:
   1. Navigating to /collections/x/lang-y dropped every other
      active filter and the sort order (bare path, no query).
   2. Shopify 302-redirects a tag URL back to the collection when
      no product carries that tag, so a language with no products
      (e.g. Japanese) could never be selected at all.
   Now: selection lives in ?cv-lang=, composes with all native
   filters (a hidden input rides along with Dawn's facet AJAX),
   and an empty language shows an honest empty state.
   Products with no lang- tag are treated as English (store default).
   ============================================================ */
(function () {
  'use strict';

  var PARAM = 'cv-lang';
  var TAG_PREFIX = 'lang-';
  var DEFAULT_LANG = 'english';

  function currentLang() {
    return (new URLSearchParams(window.location.search).get(PARAM) || '').toLowerCase();
  }

  function langOf(link) {
    var label = link.querySelector('span:last-child');
    return label ? label.textContent.trim().toLowerCase() : '';
  }

  /* Normalise legacy tag paths: /collections/x/lang-english → /collections/x */
  function basePath() {
    return window.location.pathname.replace(/\/lang-[a-z0-9-]+\/?$/, '');
  }

  function buildUrl(lang, isActive) {
    var params = new URLSearchParams(window.location.search);
    if (isActive) params.delete(PARAM);
    else params.set(PARAM, lang);
    params.delete('page');
    var qs = params.toString();
    return basePath() + (qs ? '?' + qs : '');
  }

  /* Hidden input inside the facet form(s) so Dawn's AJAX filtering
     serialises cv-lang into every URL it builds — other filters no
     longer wipe the language selection. */
  function syncHiddenInputs(lang) {
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm').forEach(function (form) {
      var input = form.querySelector('input[name="' + PARAM + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = PARAM;
        form.appendChild(input);
      }
      if (input.value !== lang) input.value = lang;
      input.disabled = !lang;
    });
  }

  function syncLinks() {
    var lang = currentLang();
    document.querySelectorAll('.cv-lang-link').forEach(function (link) {
      var l = langOf(link);
      var active = l === lang && l !== '';
      link.classList.toggle('cv-lang-link--active', active);
      var box = link.querySelector('.cv-lang-box');
      if (box) box.classList.toggle('cv-lang-box--on', active);
      link.setAttribute('href', buildUrl(l, active));
      if (link.dataset.cvLangBound !== '1') {
        link.dataset.cvLangBound = '1';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var clicked = langOf(link);
          window.location.assign(buildUrl(clicked, clicked === currentLang()));
        });
      }
    });
    syncHiddenInputs(lang);
  }

  function matches(tagsAttr, lang) {
    var padded = ' ' + (tagsAttr || '') + ' ';
    if (padded.indexOf(' ' + TAG_PREFIX + lang + ' ') > -1) return true;
    // No explicit language tag → the product is stocked in the store's
    // default language (English), so it matches the English filter.
    if (lang === DEFAULT_LANG && padded.indexOf(' ' + TAG_PREFIX) === -1) return true;
    return false;
  }

  function applyFilter() {
    var lang = currentLang();
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var visible = 0;
    var cards = grid.querySelectorAll('[data-cv-tags]');
    cards.forEach(function (card) {
      var item = card.closest('li') || card.closest('.grid__item') || card;
      var show = !lang || matches(card.getAttribute('data-cv-tags'), lang);
      item.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    var note = document.getElementById('cv-lang-empty');
    if (lang && cards.length > 0 && visible === 0) {
      if (!note) {
        note = document.createElement('p');
        note.id = 'cv-lang-empty';
        note.style.cssText = 'padding:5rem 0;text-align:center;letter-spacing:0.08em;opacity:0.75;';
        grid.parentElement.insertBefore(note, grid.nextSibling);
      }
      var msg = 'No ' + lang.charAt(0).toUpperCase() + lang.slice(1) + ' products yet — check back soon.';
      if (note.textContent !== msg) note.textContent = msg;
      note.hidden = false;
    } else if (note && !note.hidden) {
      note.hidden = true;
    }
  }

  function refresh() {
    syncLinks();
    applyFilter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  window.addEventListener('popstate', refresh);

  /* Dawn re-renders the grid and facets over AJAX; re-apply after each render.
     refresh() is idempotent (guarded writes), so the observer cannot loop. */
  var deb;
  new MutationObserver(function () {
    clearTimeout(deb);
    deb = setTimeout(refresh, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
